<template>
    <div class="leve1">
        <div class="leve1-title"><i v-if="del" class="el-icon-error inline-block text-color-error pointer pr4" @click="handleDel(source)"></i>{{ source.label }}</div>
        <div class="leve2 pl16" v-for="(plan) in source.children" :key="plan.id">
            <div class="leve2-title" :title="plan.label"><i v-if="del" class="el-icon-error inline-block text-color-error pointer pr4" @click="handleDel(plan)"></i>{{ plan.label }}</div>
        </div>
    </div>
  </template>
  
  <script>
    export default {
      name: 'item-component',
      props: {
        index: { // index of current item
          type: Number
        },
        source: { // here is: {uid: 'unique_1', text: 'abc'}
          type: Object,
          default () {
            return {}
          }
        },
        del: {
          type: Boolean,
          default: false
        }
      },
      methods: {
        handleDel (source) {
          this.$bus.$emit('del', source.id)
        }
      }
    }
  </script>
  <style scoped lang="scss">
  .leve1-title, .leve2-title{
        line-height: 22px;
        white-space: nowrap;
    }
  </style>